
import { MultilocationCategorySelector } from "components/WebDesigner/StyleInputs/MultilocationCategorySelector";
import React, { useState, useRef, useEffect } from "react"


export default function MultiLocationCheckSelectWrapper({ allLocation,defaultBID, selectedLocations, updateFunc,forceSelected }: {defaultBID:string, allLocation: any, selectedLocations: any, updateFunc: (selection: any) => void,forceSelected:string[] }) {
  //eslint-disable-next-line
  const [isExpanded, setIsExpanded] = useState(true);

  let locationData:any =[];

  for(let i = 0;i<allLocation.length;i++){
      if(allLocation[i].isParent){
        locationData.push(
            { id: allLocation[i].value,parentId:allLocation[i].parentId, text: allLocation[i].label, children: [] }
          );
      }
  }

  for(let i = 0;i<allLocation.length;i++){
    if(!allLocation[i].isParent){
      let parent = locationData.find((d:any)=>d.parentId==allLocation[i].parentId);
      if(parent){
        
        parent.children.push({ id: allLocation[i].value, text: allLocation[i].label });
      }
    }

  }

  for(let i = 0;i<locationData.length;i++){
    if(locationData[i].children.length==0){

      locationData[i].children.push({ id: locationData[i].id, text: "" });
    }

  }



  const dropDownRef = useRef<any>();

  let styleString = `.check-selector{
                            max-height: 400px;
                            overflow: auto;
                        
                        }
                        
                        .check-selector > *{
                            flex-shrink: 0;
                        }
    `;
  
  if(forceSelected){
      for(let i = 0;i<forceSelected.length;i++){

          styleString += `#check-${forceSelected[i]}{opacity:.5; pointer-events:none;}`;
      
      }
  }
    


  // // let selectedString = "All";

  // let count = 0;
  // let total = 0;

  // for (let j = 0; j < locationData.length; j++) {
  //   total += locationData[j].children.length;
 
  //   for (let k = 0; k < locationData[j].children.length; k++) {
  //     let loc = locationData[j].children[k];

  //     if(selectedLocations.includes(loc.id)||forceSelected.includes(loc.id)){
  //       count++;
  //       if (count == 1)
  //         //selectedString = locationData[j].children[k].text;
  //     }
  //   }
  // }

  // if (count >= total) {
  //   selectedString = "All";
  // }

  // else if (count > 1) {
  //   selectedString = (count) + " Selected";
  // }


  useEffect(() => {
    updateFunc([...selectedLocations, ...forceSelected]);
 //eslint-disable-next-line
  },[allLocation]);

  return (
    <>
      <style>
        {styleString
        }
      </style>

      <div ref={dropDownRef}  >
        {isExpanded && (
          <div className="flex-column h-full" >
          
            <MultilocationCategorySelector
              toolTipId={defaultBID}
              showFilter={true}
              useAmbiguous={true}
              forceSelected={forceSelected}
              catagories={locationData.map((d: any, i: number) => {
                return {
                  id: i,
                  name: d.text,
               
                  items: d.children.map((c: any, j: number) => {
                    return { id: c.id, name: c.text, checked: selectedLocations.includes(c.id)||forceSelected.includes(c.id)};
                  }),
                };
              })}
              onUpdate={(selected) => {
                let selectedIds = [];
                for (let i = 0; i < selected.length; i++) {
                  for (let j = 0; j < selected[i].items.length; j++) {
                    if (selected[i].items[j].checked) {
                      selectedIds.push(selected[i].items[j].id);
                    }
                  }
                }
                updateFunc([...selectedIds, ...forceSelected]);

              }}
            /></div>
        )}
      </div>
      <div style={{ display: "none" }}>

      </div>
    </>
  );
}